<template>
  <div :id="random_id"
       :data-testid="props.dataTestid"
       v-if="props.data && props.data.length > 0"
       :class="twMerge('highlights-carousel mb-4 lg:mb-[18px]', props.appendClass)"
  >
    <TsCarouselV2
        v-bind="$attrs"
        :navigation="!isMobile && !isTablet"
    >
      <TsCarouselSlide
          v-for="item in props.data"
          :key="item.id"
          append-class="flex-[0_0_calc(100%/1.1)] sm:flex-[0_0_calc(100%/2)] lg:flex-[0_0_calc(100%/3)]"
      >
        <TsCardHighlights
            :id="item.id ?? null"
            :variant="item.variant"
            :brand_logo="item.brand_logo"
            :brand_logo_alt="item.brand_logo_alt"
            :title="item.title"
            :type="item.type"
            :image="item.image"
            :image_alt="item.image_alt"
            :dataTestid="dataTestid"
        />
      </TsCarouselSlide>
    </TsCarouselV2>
  </div>
</template>

<script setup lang="ts">
const {isMobile, isTablet} = useDevice();
import {twMerge} from "tailwind-merge";
import {onMounted, ref} from "vue";
import { useRandomUUID } from "../../composables/useRandomUUID";
import type { HighlightCardProps } from "./TsCardHighlights.vue";

const TsCarouselV2 = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselV2.vue')
);

const TsCarouselSlide = defineAsyncComponent(
    () => import('~/components/organisms/TsCarouselSlide.vue')
);

const TsCardHighlights = defineAsyncComponent(
    () => import('~/components/organisms/TsCardHighlights.vue')
);

defineOptions({
  inheritAttrs: false,
});


type Props = {
  dataTestid?: string;
  appendClass?: string;
  data?: HighlightCardProps[];
}

const props = withDefaults(defineProps<Props>(), {
  data: () => ([
    {
      id: "1",
      brand_logo: "/images/logos/makita.png",
      brand_logo_alt: "brand logo for highlighted product",
      title: "Avail benefits up to €199.00",
      variant: 'navy-blue',
      type: "Cordless Drill",
      image: "/images/makita-tool.png",
      image_alt: "highlighted product with deal"
    }
  ]),
  dataTestid: "carousel-highlight"
});

const random_id = ref("");

onMounted(() => {
  random_id.value = useRandomUUID();
})
</script>
